// extracted by mini-css-extract-plugin
module.exports = {"signInForm":"_2t4jQzH0b6hwROdYBPN0u0"};